export const initialFormValues = {
  category: '',
  description: '',
  unit: '',
  quantity: '',
  unitValue: '',
  totalValue: ''
}
